import React, { FC } from "react";

import Portal from "../services/Portal";

type Props = {
	children: JSX.Element;
};

const ToasterModalWindow: FC<Props> = ({ children }) => {
	return (
		<Portal>
			<div
				style={{
					position: "fixed",
					width: "100%",
					height: "100%",
					background: "transparent",
					left: "0",
					top: "0",
					zIndex: "9999999",
					overflow: "auto",
					pointerEvents: "none",
				}}
			>
				{children}
			</div>
		</Portal>
	);
};
export default ToasterModalWindow;
